const styles = (_theme) => ({});

export default styles;
